export default "__VITE_ASSET__BfgEoNz9__"